/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Opaque reference to stored content; no credentials
 * @export
 * @interface ContentRef
 */
export interface ContentRef {
    /**
     * Storage provider identifier (e.g. LEGACY_RAW_DATA, AZURE_BLOB)
     * @type {string}
     * @memberof ContentRef
     */
    provider?: string;
    /**
     * Location key (e.g. raw data entity ID, blob path)
     * @type {string}
     * @memberof ContentRef
     */
    key?: string;
}

/**
 * Check if a given object implements the ContentRef interface.
 */
export function instanceOfContentRef(value: object): value is ContentRef {
    return true;
}

export function ContentRefFromJSON(json: any): ContentRef {
    return ContentRefFromJSONTyped(json, false);
}

export function ContentRefFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentRef {
    if (json == null) {
        return json;
    }
    return {
        
        'provider': json['provider'] == null ? undefined : json['provider'],
        'key': json['key'] == null ? undefined : json['key'],
    };
}

export function ContentRefToJSON(json: any): ContentRef {
    return ContentRefToJSONTyped(json, false);
}

export function ContentRefToJSONTyped(value?: ContentRef | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider': value['provider'],
        'key': value['key'],
    };
}

